/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Project_References_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "Documents the project relies on repeatedly, such as style guides, product docs, or a knowledge space. They stay available to every chat without anyone re-att..." |
*
* @param {Uno_Edu_Project_References_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_project_references_chip1_answer = /** @type {((inputs?: Uno_Edu_Project_References_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Project_References_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dokumente, auf die das Projekt wiederholt zurückgreift, etwa Styleguides, Produktdokumentationen oder einen Wissens-Space. Sie bleiben in jedem Chat verfügbar, ohne dass jemand sie erneut anhängen muss.")
	return /** @type {LocalizedString} */ ("Documents the project relies on repeatedly, such as style guides, product docs, or a knowledge space. They stay available to every chat without anyone re-attaching them.")
});